import * as React from "react";
import * as ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { ProviderConfig } from 'launchdarkly-react-client-sdk/lib/types';
import { getLaunchDarklyProviderDetails } from './services/launchDarklyConfigService';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import App from "./App";
import '../src/assets/fonts/AvertaDemoPECuttedDemo-Regular.otf'
import AuthProvider from "./provider/AuthProvider/AuthProvider";
import UserDetailsProvider from "./provider/AuthProvider/UserDetailsProvider";
import ErrorBoundary from './components/shared/ErrorBoundary/ErrorBoundary';
import './config/api.interceptor';
import UserDetails from "./common/model/UserDetails";
import { EAccountStatus } from "./common/enum/EAccountStatus";
import SnackBarContextProvider  from "./provider/SnackbarProvider";


(async () => {
  const launchDarklyConfig: ProviderConfig = getLaunchDarklyProviderDetails();
  const LDProvider = await asyncWithLDProvider({
    ...launchDarklyConfig
  });
  var container = document.getElementById('output');

  const getUserDetails = (): UserDetails => {
    let userInfoObject = container?.getAttribute("userInfo") != null ? container?.getAttribute("userInfo") : "";
    var userDetails: UserDetails = new UserDetails();
    if (userInfoObject) {
      Object.assign(userDetails, JSON.parse(userInfoObject));
    }
    return userDetails;
  }

  const getAccountStatus = (): EAccountStatus => {
    let accountStatusObject = getUserDetails().AccountStatus
    var AccountStatus = EAccountStatus.Sandbox;
    if (accountStatusObject) {
      AccountStatus = accountStatusObject;
    }
    return AccountStatus;
  }

  ReactDOM.render(
    <AuthProvider>
      <UserDetailsProvider>
        <LDProvider>
          <BrowserRouter>
            <ErrorBoundary>
              <SnackBarContextProvider>
                <App userDetails={(getUserDetails())} isLoggedIn={(Boolean(container?.getAttribute("isLoggedIn")))}
                  AccountStatus={getAccountStatus()} />
              </SnackBarContextProvider>
            </ErrorBoundary>
          </BrowserRouter>
        </LDProvider>
      </UserDetailsProvider>
    </AuthProvider>,
    document.getElementById("output")
  );
})();
